import {
  Box,
  Card,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useGetOne } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import { saveCachedMenuStats } from "../../layout/PreloadMenuStats";
import DocumentsIcon from "../../unit/svgIcon/DocumentsIcon";
import FinancialIcon from "../../unit/svgIcon/FinancialIcon";
import HistoryIcon from "../../unit/svgIcon/HistoryIcon";
import TransUnionIcon from "../../unit/svgIcon/TransUnionIcon";
import UnderwritingIcon from "../../unit/svgIcon/UnderwritingIcon";
import useNotify from "../../unit/useNotify";
import VerticalSpacer from "../../unit/VerticalSpacer";
import FinancialConditionShow from "../detailpages/FinancialConditionShow";
import TransUnionShow from "../detailpages/TransUnionShow";
import ApplicationActions from "../summary/ApplicationActions";
import ApplicationBaseDataAside from "../summary/ApplicationBaseDataAside";
import ApplicationBaseInfoHeader from "../summary/ApplicationBaseInfoHeader";
import ApplicationDocuments from "../summary/ApplicationDocuments";
import ApplicationHistory from "../summary/ApplicationHistory";
import ApplicationUnderwritingData from "../summary/ApplicationUnderwritingData";

const MainContent = styled("main")({
  paddingTop: "10px",
  height: `calc(100vh - 282px)`,
  backgroundColor: "#fff",
  width: "100%",
  maxWidth: "100%",
  minWidth: "100%",
  wordBreak: "break-word",
  overflowX: "auto",
  textOverflow: "ellipsis",
  whiteSpace: "normal",
});

const HeaderContent = styled("header")({
  position: "sticky",
  top: 0,
  paddingLeft: "0px",
  paddingRight: "0px",
  width: "100%",
  height: "120px",
  backgroundColor: "#fff",
});

const FooterContent = styled("footer")({
  background: "#fff",
  position: "sticky",
  paddingTop: "16px",
  paddingLeft: "0px",
  bottom: 0,
  width: "100%",
  height: "60px",
  borderTop: "1px solid #ddd",
});

const ApplicationSummaryTabShowBody = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [showTabOne, setShowTabOne] = useState(true); //review history
  // const [showTabOne, setShowTabOne] = useState(true);
  const [showTabTwo, setShowTabTwo] = useState(false); //documents
  const [showTabThree, setShowTabThree] = useState(false); //underwriting summary
  // const [showTabThree, setShowTabThree] = useState(false);
  const [showTabFour, setShowTabFour] = useState(false); //transunion
  const [showTabFive, setShowTabFive] = useState(false); //reserved for future use
  const [showTabSix, setShowTabSix] = useState(false); //financial condition
  const [appStatus, setAppStatus] = useState("");
  const [requirementSaved, setRequirementSaved] = useState("");

  const isMounted = React.useRef(false);
  const renderCountRef = React.useRef(0);

  const handleDataChange = (newData: any) => {
    props?.onDataChange?.(newData);
  };

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      renderCountRef.current += 1;
    }
  });
  const appId = props.appId;
  interface RecordType {
    sReview: any;
    sStatus: string;
    showNextprocess: number;
    sExecuteStatus: string;
    sNeedDisbursement: string;
    disbursementStatus: string;
    sDisbursementPayment: string;
    ach_account_id: string;
    requirementSaved: string;
    sApplicationResponse: string;
    // Add other properties of the record as needed
  }

  const [record, setRecord] = useState<RecordType | null>(null);
  if (appId == "" || appId == undefined || appId == null) {
    return <Typography>Loading Error, missing Application ID</Typography>;
  }
  const { data, isPending, error } = useGetOne("applications", {
    id: appId,
  });

  useEffect(() => {
    setRecord(data);
    setRequirementSaved(data?.requirementSaved);
    if (data) {
      setAppStatus(data.sStatus);
    }
    let appStatus = data?.sStatus;
    if (!showTabTwo) {
      if (appStatus == "Initial Review" || appStatus == "restart") {
        setShowTabThree(true);
        setShowTabOne(false);
        setShowTabTwo(false);
        setShowTabFour(false);
        setShowTabFive(false);
        setShowTabSix(false);
      } else if (
        appStatus == "Incomplete" ||
        ((appStatus == "New" || appStatus == "Check") &&
          data?.showNextprocess == 1)
      ) {
        setShowTabTwo(true);
        setShowTabOne(false);
        setShowTabThree(false);
        setShowTabFour(false);
        setShowTabFive(false);
        setShowTabSix(false);
      }
    }
  }, [appId, data]);

  if (error) {
    errorNotify("Error loading Application " + error);
  }
  if (isPending) {
    return <Typography>Application Loading</Typography>;
  }

  const handleShowTab = (tabnum: number) => {
    if (tabnum == 1 || tabnum == null) {
      setShowTabOne(true);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
    } else if (tabnum == 2) {
      setShowTabOne(false);
      setShowTabTwo(true);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
    } else if (tabnum == 3) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(true);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
    } else if (tabnum == 4) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(true);
      setShowTabFive(false);
      setShowTabSix(false);
    } else if (tabnum == 5) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(true);
      setShowTabSix(false);
    } else if (tabnum == 6) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(true);
    }
  };

  async function handleNewAppStatus(
    newAppStatus: any,
    otherData?: Partial<RecordType>
  ): Promise<void> {
    // let reqUrl = "applications/baseInfo";
    let reqUrl = "applications/getappinfo";
    const response = await sendRequest(reqUrl, {
      id: appId,
    });
    if (response) {
      // setAppStatus(response.status);
      setAppStatus(response.sStatus);

      localStorage.removeItem("applicationMenuStats");
      if (response) {
        let newRecord: RecordType = { ...response };
        if (otherData) {
          for (const key in otherData) {
            if (key == "requirementSaved") {
              setRequirementSaved(otherData[key]);
            }
            (newRecord as any)[key] = otherData[key];
          }
        }
        setRecord(newRecord);
        // console.log("Updated record from server response:", response);
      }
      // if (record) {
      //   let newRecord: RecordType = { ...record };
      //   newRecord.sStatus = record?.sStatus;
      //   newRecord.sReview = record?.sReview;
      //   if (otherData) {
      //     for (const key in otherData) {
      //       if (key == "requirementSaved") {
      //         setRequirementSaved(otherData[key]);
      //       }
      //       (newRecord as any)[key] = otherData[key];
      //     }
      //   }

      //   setRecord(newRecord);
      // }
    }
  }

  if (!record || record?.code == 201) {
    return (
      <Typography
        sx={{
          mt: 5,
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "gray",
        }}
      >
        {record?.message || "Application not found"}
      </Typography>
    );
  }
  if (appStatus == "Incomplete") {
    return (
      <Typography
        sx={{
          mt: 5,
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "gray",
        }}
      >
        This application is currently Incomplete.
      </Typography>
    );
  }
  return (
    record && (
      <Grid container columnSpacing={1} sx={{ mb: 0 }}>
        <Grid
          item
          sx={{
            width: "300px",
            maxWidth: "300px",
            marginLeft: "0px",
            flexShrink: 0,
            mb: 0,
            "&.MuiGrid-item": { paddingLeft: "0px !important" },
          }}
        >
          <ApplicationBaseDataAside
            appId={appId}
            record={record}
            appStatus={appStatus}
            requirementSaved={requirementSaved}
          />
        </Grid>
        <Grid
          item
          xs
          sx={{
            minWidth: 0,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            ml: "10px",
            padding: 0,
            "&.MuiGrid-item": { paddingLeft: "0px !important" },
          }}
        >
          <Grid container sx={{ width: "100%" }}>
            <Grid
              item
              sx={{ width: "calc(100% - 55px)" }}
              id={"rightbody-application-summary-" + appId}
            >
              <Card sx={{ mt: 1, p: "10px", overflowY: "auto" }}>
                <HeaderContent id="headercontent-application-summary">
                  <Box
                    sx={{
                      width: "100%",
                      backgroundColor: "#f8f9f9",
                      height: "120px",
                    }}
                  >
                    <ApplicationBaseInfoHeader
                      appId={appId}
                      record={record}
                      appStatus={appStatus}
                      requirementSaved={requirementSaved}
                    />
                  </Box>
                </HeaderContent>
                <MainContent
                  id="maincontent-application-summary"
                  style={showTabThree ? { paddingBottom: "0px" } : {}}
                >
                  {showTabOne ? (
                    <div id="sectionOne" style={{ width: "100%" }}>
                      <ApplicationHistory appId={appId} record={record} />
                    </div>
                  ) : (
                    <></>
                  )}
                  {showTabTwo ? (
                    <div id="sectionTwo">
                      <ApplicationDocuments
                        appId={appId}
                        step="All"
                        substep="All"
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  {showTabThree ? (
                    <div id="sectionThree" style={{ overflow: "hidden" }}>
                      <ApplicationUnderwritingData
                        appId={appId}
                        record={record}
                        appStatus={appStatus}
                        cb={handleNewAppStatus}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  {showTabFour ? (
                    <div id="sectionFour">
                      <TransUnionShow
                        appId={appId}
                        record={record}
                        appStatus={appStatus}
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  {showTabSix ? (
                    <div id="sectionSix">
                      <FinancialConditionShow
                        appId={appId}
                        record={record}
                        appStatus={appStatus}
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  <VerticalSpacer h={5} />
                </MainContent>

                <FooterContent>
                  <ApplicationActions
                    appId={appId}
                    record={record}
                    appStatus={appStatus}
                    requirementSaved={requirementSaved}
                    cb={handleNewAppStatus}
                  />
                </FooterContent>
              </Card>
            </Grid>
            <Grid
              item
              sx={{
                width: "55px",
                maxWidth: "55px",
                textAlign: "right",
                mt: 2,
              }}
              id={"rightaside-application-summary-" + appId}
            >
              <Tooltip placement="left-start" title={"Review History"}>
                <IconButton
                  onClick={() => handleShowTab(1)}
                  // title="Review History"
                  className={showTabOne ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-history"
                >
                  <HistoryIcon color={showTabOne ? "white" : "#1976d2"} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Uploaded Documents" placement="left-start">
                <IconButton
                  onClick={() => handleShowTab(2)}
                  // title="Uploaded Documents"
                  className={showTabTwo ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-documents"
                >
                  <DocumentsIcon color={showTabTwo ? "white" : "#1976d2"} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Underwriting Summary" placement="left-start">
                <IconButton
                  onClick={() => handleShowTab(3)}
                  // title="Underwriting Summary"
                  className={showTabThree ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-underwriting"
                >
                  <UnderwritingIcon
                    color={showTabThree ? "white" : "#1976d2"}
                  />
                </IconButton>
              </Tooltip>

              <Tooltip title="Credit Reports" placement="left">
                <IconButton
                  onClick={() => handleShowTab(4)}
                  // title="Credit Reports"
                  className={showTabFour ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-transunion"
                >
                  <TransUnionIcon color={showTabFour ? "white" : "#1976d2"} />
                </IconButton>
              </Tooltip>

              <Tooltip title="Financial Analysis" placement="left">
                <IconButton
                  onClick={() => handleShowTab(6)}
                  // title="Financial Analysis"
                  className={showTabSix ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-financial"
                >
                  <FinancialIcon color={showTabSix ? "white" : "#1976d2"} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  );
};

export default ApplicationSummaryTabShowBody;
